<template>
    <div>
        <div class="header__title d-flex align-items-center mt-2 mb-4">
            <div style="font-weight: 500;">
                Chọn ngày đóng tiền:
                <el-date-picker
                    v-model="optionDate"
                    type="date"
                    format="dd-MM-yyyy"
                    value-format="yyyy-MM-dd"
                    :picker-options="datePickerOptions"
                    class="ml-2"
                    placeholder="Chọn ngày"
                    :clearable="false"
                />
            </div>
        </div>

        <!-- Nhập tiền -->
        <div class="input-amount">
            <div class="input-amount__container">
                <div class="auto_amount__input d-flex mb-2">
                    <div style="font-weight: 500; color:rgba(0, 0, 0, 1)" class="input-amount__input--label mr-2">Số tiền: </div>
                    <div class="input-amount__input--value d-flex">
                        <div v-for="(item, index) in autoMoney" :key="index">
                            <div class="input-amount__input--value-item">
                                <div @click="amount = item.toLocaleString('vi-VN')"  style="background-color: #65558F; color:#FFFFFF; font-size: 11px; padding: 2px 6px 1px 5px;"
                                     class="cursor-pointer input-amount__input--value-item-value mr-2 auto-amount rounded-pill">
                                    {{ item?.toLocaleString('vi-VN') }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-flex align-items-center mb-2">
                <el-input
                    style="border-color: rgba(173, 173, 173, 1); color: rgba(255, 255, 255, 1);"
                    placeholder="Nhập số tiền..."
                    v-model="amount"
                    @input="formatAmount">
                </el-input>
                <el-button :disabled="loading" @click="submitInputAmount()" style="background-color: #472F92;" class="ml-1 text-white"><i :class="loading ? 'el-icon-loading' : ''"></i> Nhập</el-button>
            </div>

            <div>
                <div >
                    <el-table
                        :data="tableDataHistory"
                        style="width: 100%; max-height: 200px; overflow-y: auto;">
                        <el-table-column
                            label="Số tiền">
                            <template v-slot="scope">
                                <span style="margin-left: 10px">{{ scope.row?.import_amount?.toLocaleString('vi-VN') }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="Thời gian nhập"
                        >
                            <template v-slot="scope">
                                <span style="margin-left: 10px">{{ scope.row?.created_at | formatDate }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            align="center"
                            label="Hành động">
                            <template v-slot="scope">
                                <i
                                    v-if="canEdit(scope.row.created_at)"
                                    class="el-icon-edit text-primary cursor-pointer mr-2"
                                    @click="handleEdit(scope.row)"
                                    title="Chỉnh sửa"
                                ></i>

                                <i
                                    class="el-icon-delete text-danger cursor-pointer"
                                    @click="handleDelete(scope.row.id, scope.row.import_amount)"
                                    title="Xoá"
                                ></i>
                            </template>
                        </el-table-column>

                    </el-table>
                </div>
            </div>

            <div slot="footer" class="dialog-footer mt-4 mb-4 d-flex justify-content-end">
                <el-button @click="close">Đóng</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment-timezone";
import Swal from 'sweetalert2';
import { INPUT_AMOUNT, GET_HISTORY_SALE_IMPORT, DELETE_IMPORT_AMOUNT, CHANGE_INPUT_AMOUNT } from '../../../../core/services/store/customer/customer.module';

export default {
    name: "InputAmount",
    props: {
        customer:{
            type: [Array, Object],
            required: true,
        },
        is_show:{
            type: Boolean,
            required: false,
        },
    },
    watch: {
        is_show: {
            handler(newVal) {
                if (newVal) {
                    this.tableDataHistory = [];
                    this.getHistory();
                }else {
                    this.amount = '';
                }
            },
            immediate: true
        }
    },
    data() {
        return {
            optionDate: moment().format('YYYY-MM-DD HH:mm:ss'),
            datePickerOptions: {
                disabledDate(time) {
                    const today = moment().endOf('day');
                    const threeDaysAgo = moment().subtract(3, 'days').startOf('day');
                    return time < threeDaysAgo.toDate() || time > today.toDate();
                }
            },
            autoMoney: {
                1 : 10000000,
                2 : 3000000,
                3 : 2000000,
                4 : 5000000,
            },
            amount: '',
            loading: false,
            tableDataHistory: []
        };
    },
    methods: {
        handleDelete(index, import_amount) {
            Swal.fire({
                title: 'Bạn có chắc chắn muốn xoá tiền nhập?',
                text: "Bạn sẽ không thể khôi phục lại dữ liệu này!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Xóa',
                cancelButtonText: 'Hủy'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store.dispatch(DELETE_IMPORT_AMOUNT, {id:index})
                    .then((res) => {
                        if(!res.error) {
                            this.customer.total_input_amount = Number(this.customer.total_input_amount) - Number(import_amount);
                            this.$emit('reloadSaleInput');
                            this.close();
                            Swal.fire(
                                'Đã xóa!',
                                'Xoá thành công.',
                                'success'
                            );
                        }
                    })
                }
            });
        },

        submitInputAmount() {
            this.loading = true;
            if (!this.amount) {
                this.$notify({
                    title: 'Thiếu dữ liệu!',
                    message: `Vui lòng nhập số tiền muốn đóng!`,
                    type: 'warning'
                });
                this.loading = false;
                return;
            }

            const payload = {
                import_amount: Number(this.amount.replace(/\./g, '')),
                customer_id: this.customer.id,
                date: this.optionDate
            };
            this.$store.dispatch(INPUT_AMOUNT, payload)
                .then((res) => {
                    if(res) {
                        this.$notify({
                            title: 'Thành công!',
                            message: `Đóng tiền thành công!`,
                            type: 'success'
                        });
                        this.customer.total_input_amount = Number(this.customer.total_input_amount) + Number(res.import_amount);
                        this.loading = false;
                        this.$emit('reloadSaleInput');
                        this.close();
                    }
                }).finally(() => {
                this.loading = false;
            })
        },

        getHistory() {
            this.$store.dispatch(GET_HISTORY_SALE_IMPORT, {
                customer_id: this.customer.id
            })
            .then((res) => {
                this.tableDataHistory = Array.isArray(res) ? res : [];
                this.loading = false;
            })
        },

      formatAmount(val) {
        let raw = val.replace(/\./g, '');
        raw = raw.replace(/(?!^)-|[^\d-]/g, '');
        const isNegative = raw.startsWith('-');
        const numericPart = isNegative ? raw.slice(1) : raw;
        const formattedNumber = numericPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        this.amount = isNegative
            ? `-${formattedNumber}`
            : formattedNumber;
      },

        handleEdit(item) {
            Swal.fire({
                title: 'Sửa số tiền',
                input: 'text',
                inputValue: item.import_amount.toLocaleString('vi-VN'),
                inputAttributes: {
                    inputmode: 'numeric'
                },
                showCancelButton: true,
                confirmButtonText: 'Lưu',
                cancelButtonText: 'Hủy',
                didOpen: () => {
                    const input = Swal.getInput();
                    input.setSelectionRange(input.value.length, input.value.length);
                },
                preConfirm: (value) => {
                    const raw = value.replace(/\./g, '').trim();
                    const number = parseInt(raw, 10);
                    if (isNaN(number) || number <= 0) {
                        Swal.showValidationMessage('Vui lòng nhập số hợp lệ lớn hơn 0');
                        return false;
                    }
                    return number;
                }
            }).then((result) => {
                if (result.isConfirmed) {
                    const payload = {
                        id: item.id,
                        amount: result.value,
                    };
                    this.$store.dispatch(CHANGE_INPUT_AMOUNT, payload).then((res) => {
                        this.tableDataHistory = Array.isArray(res) ? res : [];
                        this.loading = false;
                    });
                    const differentAmount = result.value - item.import_amount;
                    this.customer.total_input_amount += differentAmount;
                    this.close();
                    Swal.fire('Đã cập nhật!', 'Số tiền đã được thay đổi.', 'success');
                }
            });
        },

        canEdit(dateStr) {
            const created = moment(dateStr);
            const now = moment();
            const diffDays = now.diff(created, 'days');
            return diffDays <= 3;
        },

        close() {
            this.$emit('close');
        }
    },
};
</script>

<style scoped>
.auto-amount {
    transition: margin-top 0.2s ease;
}

.auto-amount:hover {
    background-color: rgb(82 33 211) !important;
    color: #4F378A;
    font-weight: 500;
    margin-top: -3px !important;
    cursor: pointer;
}
</style>
